import { useEffect, useRef } from 'react';
import L from 'leaflet';
import { coveragePolygon } from '@/mocks/codesajan';

export default function CoverageMap() {
  const mapRef = useRef<HTMLDivElement>(null);
  const leafletMapRef = useRef<L.Map | null>(null);

  useEffect(() => {
    if (!mapRef.current || leafletMapRef.current) return;

    const map = L.map(mapRef.current, {
      scrollWheelZoom: false,
    }).setView([-21.595, -64.718], 15);

    leafletMapRef.current = map;

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    // Draw polygon
    const polygon = L.polygon(coveragePolygon as L.LatLngExpression[], {
      color: '#0ea5a0',
      fillColor: '#0ea5a0',
      fillOpacity: 0.25,
      weight: 3,
      dashArray: '6 4',
    }).addTo(map);

    // Fit bounds
    map.fitBounds(polygon.getBounds(), { padding: [40, 40] });

    // Add marker at center-ish point
    L.marker([-21.596, -64.7175])
      .addTo(map)
      .bindPopup('<b>CODESAJAN</b><br>Zona de cobertura San Jacinto Norte Zona Oeste');

    return () => {
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
      }
    };
  }, []);

  return (
    <div className="rounded-xl overflow-hidden border border-background-200/70 shadow-sm">
      <div ref={mapRef} className="w-full h-[400px] md:h-[520px]" />
    </div>
  );
}